import { applyTraceparent } from '@myosh/tracing';
import { apiBaseUrl, apiKey } from '../env';

interface ApiOptions extends Omit<RequestInit, 'body'> {
  body?: Record<string, unknown>;
}

const api = async <T>(endpoint: string, opts: ApiOptions = {}) => {
  const { body, ...rest } = opts;

  const url = `${apiBaseUrl}v4/${endpoint}`;

  const config: RequestInit = {
    method: 'GET',
    ...rest,
    headers: {
      'content-type': 'application/json',
      'x-api-key': apiKey,
      ...rest.headers,
    },
    ...(body !== undefined && { body: JSON.stringify(body) }),
  };

  // W3C trace context on the shared auth/cluster/schema fetch (allow-list gated;
  // no-op when apiBaseUrl is unset, e.g. the mobile WebView build).
  applyTraceparent(config.headers as Record<string, unknown>, url, { allowedBaseUrl: apiBaseUrl });

  const response = await fetch(url, config);

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(`HTTP error. Status: ${response.status}. Message: ${errorMessage}`);
  }

  const data: T = await response.json();
  return data;
};

export default api;
